import React from 'react';
import { ThemeProvider } from '@fairygodboss/ui';
import { ContentBody } from './ContentBody/ContentBody';
import { Comments } from '../SharedComponents/Comments/Comments';
import { RecentContent } from './RecentContent/RecentContent';
import { BottomConvincer } from '../SharedComponents/BottomConvincer/BottomConvincer';
import { useCommunityContent } from './CommunityContentContext';
import { ResetStyle } from '../SharedComponents/ResetStyle';

export const CommunityContentLandingPage = () => {
    return (
        <ResetStyle>
            <ThemeProvider>
                <ContentBody />
                <Comments context={useCommunityContent} />
                <RecentContent />
                <BottomConvincer />
            </ThemeProvider>
        </ResetStyle>
    );
};
